import { render, staticRenderFns } from "./TheVisiting.vue?vue&type=template&id=5aa3237e&scoped=true&"
import script from "./TheVisiting.vue?vue&type=script&lang=js&"
export * from "./TheVisiting.vue?vue&type=script&lang=js&"
import style0 from "./TheVisiting.vue?vue&type=style&index=0&id=5aa3237e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3237e",
  null
  
)

export default component.exports